import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { ImpersonationService } from '../services/impersonation.service';

@Component({
  selector: 'ic-impersonation-banner',
  imports: [NzIconDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (impersonationService.isImpersonating()) {
      <div class="ic-impersonation-banner">
        <div class="ic-impersonation-banner__content">
          <span class="ic-impersonation-banner__label">Impersonation mode</span>
          @if (impersonationService.getImpersonatedUser(); as user) {
            <span class="ic-impersonation-banner__details">
              Logged in as {{ user.email }}
            </span>
          }
          @if (impersonationService.isReadOnlyImpersonation()) {
            <span class="ic-impersonation-banner__details">
              Read-only access is enabled
            </span>
          }
        </div>
        <button
          type="button"
          class="ic-impersonation-banner__exit"
          aria-label="Exit impersonation"
          title="Exit impersonation"
          (click)="impersonationService.exit()"
        >
          <span nz-icon nzType="logout"></span>
        </button>
      </div>
    }
  `,
  styles: [
    `
      .ic-impersonation-banner {
        position: sticky;
        top: 0;
        z-index: 1000;
        width: 100%;
        background: #fff7e6;
        border-bottom: 1px solid #ffd591;
        color: #ad4e00;
        display: flex;
        align-items: center;
      }

      .ic-impersonation-banner__content {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        align-items: center;
        justify-content: center;
        padding: 10px 16px;
        font-size: 13px;
        font-weight: 500;
        text-align: center;
      }

      .ic-impersonation-banner__label {
        text-transform: uppercase;
        letter-spacing: 0.08em;
      }

      .ic-impersonation-banner__details {
        text-transform: none;
      }

      .ic-impersonation-banner__exit {
        margin-right: 16px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        padding: 0;
        border: none;
        border-radius: 6px;
        background: none;
        color: inherit;
        font-size: 16px;
        cursor: pointer;
      }

      .ic-impersonation-banner__exit:hover {
        color: #92400e;
      }
    `,
  ],
})
export class IcImpersonationBannerComponent {
  protected readonly impersonationService = inject(ImpersonationService);
}
